import { useReduxState } from 'hooks';
import { Alert } from 'components/common';
import { Icon } from 'components/common/icons';

import type { AllTaskBlocks } from 'shared-types';

interface Props {
  data: AllTaskBlocks;
}

const EditorBlockRequireAnswerToProceedInfo = ({ data }: Props) => {
  const { messages } = useReduxState();

  return data?.requireAnswerToProceed ? (
    <Alert
      icon="info-circle"
      style={{ marginTop: 25 }}
      text={
        <div>
          {messages.editorBlockRequireAnswerToProceedInfo}

          <div
            aria-label={messages.editorBlockRequireAnswerToProceedInfoDetailed}
            data-tooltip={
              messages.editorBlockRequireAnswerToProceedInfoDetailed
            }
            style={{ display: 'inline-block', marginLeft: 5 }}
          >
            <Icon icon="question-circle" />
          </div>
        </div>
      }
      type="warning-light"
    />
  ) : null;
};

export default EditorBlockRequireAnswerToProceedInfo;
